import Indicador from "..";
import DPEditFields from "./components/DPEditFields";
import { DPParamFields } from "./components/DPParamFields";
import dpReport from "./reports";
import dpReportSummary from "./reports/summary";

export default class DP extends Indicador {
    static get fullName() {
        return "Distância entre Plantas";
    }

    static get abbrev() {
        return "DP";
    }

    static paramFields(tipoIndicadorField = '') {
        return <DPParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <DPEditFields visita={visita}  TipoClass={TipoClass}/>
    }

    async renderReport(visita) {
        return dpReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return dpReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;

        for (const coleta of apontamento.coletas) {
            if (f(coleta.espacamento) >= f(params.intervaloMin) && f(coleta.espacamento) <= f(params.intervaloMax)) {
                coleta.conforme = "Sim";
                coleta.acima = 0
                coleta.abaixo = 0
                conformeCount++;
            } else {
                coleta.conforme = "Não";
                if (f(coleta.espacamento) > f(params.intervaloMax)) {
                    coleta.acima = 1
                    coleta.abaixo = 0
                } else {
                    coleta.acima = 0
                    coleta.abaixo = 1
                }
            }
        }

        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 88.37, 100, 110.46);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.espacamento)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getResultStr(apontamento) {
        return ""
    }
}
